import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { colorsV2 } from "../../styles/colors";
import Button from "@material-ui/core/Button";
import * as actionCreators from "../../actions/whiteLabelSettings";

const ResetError = (props) => {
  const [errorType, setErrorType] = useState(null);

  useEffect(() => {
    if (props.match && props.match.params && props.match.params.type) {
      setErrorType(props.match.params.type);
    }
  }, [props]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          border: "solid 1px grey",
          padding: 30,
          borderRadius: 10,
          margin: 30,
        }}
      >
        {errorType !== null && errorType === "expired" && (
          <div>
            <h1
              style={{
                textAlign: "center",
                color: props.whiteLabelSettings.isWhiteLabel
                  ? props.whiteLabelSettings.primaryColor
                  : colorsV2.primary,
              }}
            >
              Expired Link
            </h1>
            <p>
              Unable to reset your password. Your link has expired. Please
              return to the login screen and click Forgot/Reset Password to
              start over. You must complete the process within 10 minutes.
            </p>
          </div>
        )}
        {(errorType == null ||
          (errorType !== null && errorType === "invalid")) && (
          <div>
            <h1
              style={{
                textAlign: "center",
                color: props.whiteLabelSettings.isWhiteLabel
                  ? props.whiteLabelSettings.primaryColor
                  : colorsV2.primary,
              }}
            >
              Invalid Link
            </h1>
            <p>
              We are sorry but the link you have used is invalid. Please
              return to the login screen and click Forgot/Reset Password to
              start over. You must complete the process within 10 minutes.
            </p>
          </div>
        )}
        <div>
          <Button
            type="primary"
            variant="contained"
            onClick={() => props.history.push("/")}
            style={{
              backgroundColor: props.whiteLabelSettings.isWhiteLabel
                ? props.whiteLabelSettings.accentColor
                : colorsV2.lightningYellow,
              color: "white",
            }}
          >
            Back To Login
          </Button>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps({ whiteLabelSettings }) {
  return {
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetError);



// WEBPACK FOOTER //
// ./src/layout/PasswordReset/PasswordResetError.js